module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/main-visual-text-975843b08a479e325cf984a6e0c16739.png";